/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as TYPES from './action-types';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { UPDATE_NUM_OF_UNITS } from '../../../../SharedModules/services/service';
import { RegularSuppData } from '../utils/constant';
import { getDateTimeStamp } from '../../../../SharedModules/DateUtilities/DateUtilities';
import { convertFromDateToMMDDYYYY } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchProvideDetails,
  dispatchProvideDetailsData,
} from '../../../Display/Provider/store/action';
import {
  setSearchByDrugName
} from '../../../Display/NDC/store/action';

import * as ConstantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { getDisputeResolutionToggleFromUserDefault } from '../../../Display/Claim/utils/constant';

export const setClaimErrorPopupMessage = (payload) => {
  return {
    type: TYPES.CLAIM_ERROR_POPUP_MESSAGE,
    payload,
  };
};

export const handleTextFieldChangeFilter = (e, name) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.NumberOfUnits.claimSelectByFilter,
    };
    currentFilter[name] = e.target.value;
    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const handleRebateProgramChangeFilter = (value, type) => {
  return (dispatch, getState) => {
    const obj = { ...getState().sharedState.NumberOfUnits.claimSelectByFilter };
    const currentFilter = {
      ...obj,
      rebateProgramCd:
        !obj?.rebateProgramCd || obj?.rebateProgramCd === ''
          ? value
          : type !== 'userDefault'
          ? value
          : obj?.rebateProgramCd,
      rebateProgramCdAll: value === 'ALL' ? 1 : 0,
      client: null,
      group: null,
      plan: null,
    };

    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const handleClientChangeFilter = (value) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.NumberOfUnits.claimSelectByFilter,
      client: value === -1 ? null : value,
      group: null,
      plan: null,
    };

    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const handleGroupChangeFilter = (value) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.NumberOfUnits.claimSelectByFilter,
      group: value === -1 ? null : value,
      plan: null,
    };

    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const handleSelectChangeFilter = (e, name, value) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.NumberOfUnits.claimSelectByFilter,
    };

    currentFilter[name] = e
      ? e.target.value === -1
        ? null
        : e.target.value
      : value;
    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const setClaimSelectByFilter = (payload) => {
  return {
    type: TYPES.CLAIM_SELECT_BY_FILTER,
    payload,
  };
};

export const setClaimSuccessMessage = (payload) => {
  return {
    type: TYPES.CLAIM_SUCCESS_MESSAGE,
    payload,
  };
};

export const setClaimSelectedNDCTab = (payload) => {
  return {
    type: TYPES.CLAIM_SELECTED_NDC_TAB,
    payload,
  };
};

export const setClaimSearchByDrugNameTableData = (payload) => {
  return {
    type: TYPES.CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA,
    payload,
  };
};

export const setClaimLabelerDrugTableData = (payload) => {
  return {
    type: TYPES.CLAIM_LABELER_DRUG_TABLE_DATA,
    payload,
  };
};

export const setClaimLabelerTableData = (payload) => {
  return {
    type: TYPES.CLAIM_LABELER_TABLE_DATA,
    payload,
  };
};

export const setClaimDetailsTableData = (payload) => {
  return {
    type: TYPES.CLAIM_DETAILS_TABLE_DATA,
    payload,
  };
};

export const setClaimDetailsTableRowSelected = (payload) => {
  return {
    type: TYPES.CLAIM_DETAILS_TABLE_ROW_SELECTED,
    payload,
  };
};

export const dispatchGetClaimGeneralSystemParametersResultDetails = (
  payload
) => {
  return {
    type: TYPES.CLAIM_GENERAL_PARAMETERS,
    payload,
  };
};

export const setClaimLoading = (payload) => {
  return {
    type: TYPES.CLAIM_LOADING,
    payload,
  };
};

export const setClaimCategoryCode = (payload) => {
  return {
    type: TYPES.CLAIM_CATEGORY_CODE,
    payload,
  };
};

export const setClaimReferenceData = (payload) => {
  return {
    type: TYPES.CLAIM_REFERENCE_DATA,
    payload,
  };
};

export const setClaimCategoryCodeDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_CATEGORY_CODE_DROPDOWN,
    payload,
  };
};

export const setClaimProviderIdTypeDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_PROVIDER_ID_TYPE_DROPDOWN,
    payload,
  };
};

export const setClaimRebateProgramDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_REBATE_PROGRAM_DROPDOWN,
    payload,
  };
};

export const setClaimClientDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_CLIENT_DROPDOWN,
    payload,
  };
};

export const setClaimGroupDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_GROUP_DROPDOWN,
    payload,
  };
};

export const getNOUClaimTableInfo = (payload) => ({
  type: TYPES.CUSTOM_NOU_CLAIM_TABLE_LOAD,
  payload,
});

export const setClaimSuppRadioDisable = (payload) => {
  return {
    type: TYPES.CLAIM_SUPP_RADIO_DISABLE,
    payload,
  };
};

export const setClaimPlanDropdown = (payload) => {
  return {
    type: TYPES.CLAIM_PLAN_DROPDOWN,
    payload,
  };
};

export const setNumberOfUnitSelectBy = (payload) => {
  return {
    type: TYPES.NUMBER_OF_UNITS_SELECT_BY,
    payload,
  };
};

export const setSelectedClaimNu = (payload) => {
  return {
    type: TYPES.SELECTED_CLAIM_NU,
    payload,
  };
};

export const setClaimInvoiceSelected = (payload) => {
  return {
    type: TYPES.CLAIM_INVOICED_SELECTED,
    payload,
  };
};

export const setClaimRebateType = (payload) => {
  return {
    type: TYPES.CLAIM_REBATE_TYPE,
    payload,
  };
};

export const setClaimDetailsPopup = (payload) => {
  return {
    type: TYPES.CLAIM_DETAILS_POPUP,
    payload,
  };
};

export const setSelectedClaimIndex = (payload) => {
  return {
    type: TYPES.SELECTED_CLAIM_INDEX,
    payload,
  };
};

export const setSelectedClaimFilterNu = (payload) => {
  return {
    type: TYPES.SELECTED_CLAIM_FILTER_NU,
    payload,
  };
};

export const setSelectedClaimModeNu = (payload) => {
  return {
    type: TYPES.SELECTED_CLAIM_MODE_NU,
    payload,
  };
};

export const setToggleDisputeResolution = (payload) => {
  return {
    type: TYPES.DISPUTE_RESOLUTION_TOGGLE,
    payload,
  };
};

export const setTableDataNu = (payload) => {
  return {
    type: TYPES.SET_TABLE_DATA_NU,
    payload,
  };
};

export const setDisabled = (payload) => {
  return {
    type: TYPES.SET_DISABLED_BUTTON,
    payload,
  };
};

export const setSelectedClaimRecordIndex = (payload) => {
  return {
    type: TYPES.CLAIM_SELECTED_RECORD_INDEX,
    payload,
  };
};

export const resetSelectClaimData = () => {
  return {
    type: TYPES.RESET_SELECT_CLAIM_DATA_NU,
  };
};

export const resetSelectedClaimData = () => {
  return {
    type: TYPES.RESET_SELECTED_CLAIM_DATA,
  };
};

export const setEnteredNdc = (payload) => {
  return {
    type: TYPES.ENTERED_NDC,
    payload,
  };
};

export const setNumUnitLoading = (payload) => {
  return {
    type: TYPES.UNIT_LOADING,
    payload,
  };
};

export const setNumOfUnitRes = (payload) => {
  return {
    type: TYPES.UNIT_RESPONSE,
    payload,
  };
};

export const checkClaimAndAddToDetailsTable = (data) => {
  return (dispatch, getState) => {
    dispatch(setClaimLoading(true));
    const currentDetailsTableData = [
      ...getState().sharedState.NumberOfUnits.claimDetailsTableData,
    ];
    if (data.length === 1) {
      const index = currentDetailsTableData.findIndex(
        (item) => item.ndc === data[0].ndc
      );

      if (index === -1) {
        currentDetailsTableData.push({
          ndc: data[0].ndc,
          drugName: data[0].drugName,
          ...data[0],
        });

        dispatch(setClaimDetailsTableData(currentDetailsTableData));
      } else {
        dispatch(setClaimErrorPopupMessage('NDC already added'));
      }
    } else {
      data.forEach((ndcItem) => {
        const index = currentDetailsTableData.findIndex(
          (item) => item.ndc === ndcItem.ndc
        );

        if (index === -1) {
          currentDetailsTableData.push({
            ndc: ndcItem.ndc,
            drugName: ndcItem.drugName,
            ...ndcItem,
          });
        }
      });
      dispatch(setClaimDetailsTableData(currentDetailsTableData));
    }
    dispatch(setClaimLoading(false));
  };
};

export const removeFromClaimDetailsTableData = () => {
  return (dispatch, getState) => {
    const currentDetailsTableData = [
      ...getState().sharedState.NumberOfUnits.claimDetailsTableData,
    ];
    const currentDetailsTableSelectedRow = [
      ...getState().sharedState.NumberOfUnits.claimDetailsTableRowSelected,
    ];

    if (currentDetailsTableData.length === 0) {
      dispatch(setClaimErrorPopupMessage('Nothing to remove.'));
    } else if (currentDetailsTableSelectedRow.length === 0) {
      dispatch(
        setClaimErrorPopupMessage(
          'Please select a drug to remove from the selected list.'
        )
      );
    } else {
      const updatedCurrentDetailsTableData = currentDetailsTableData.filter(
        (filterItem) =>
          currentDetailsTableSelectedRow.findIndex(
            (item) => item.ndc === filterItem.ndc
          ) === -1
      );

      dispatch(setClaimDetailsTableRowSelected([]));
      dispatch(setClaimErrorPopupMessage(null));
      dispatch(setClaimDetailsTableData(updatedCurrentDetailsTableData));
    }
  };
};

export const getAllClaimReferenceData = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(serviceEndPoint.NDC_REFERENCE_DATA, {
        codeDomainList: [
          'PROVIDER_ID_TYPE_CD',
          'CLAIM_CATEGORY_CD',
          'DRUG_STATUS_CD',
        ],
      });

      if (response.data) {
        let categoryCodeData = [];
        let providerIdTypeData = [];

        if (response.data && response.data.CLAIM_CATEGORY_CD) {
          categoryCodeData = response.data.CLAIM_CATEGORY_CD.map(
            (item, index) => {
              return {
                ...item,
                index,
                label: `${item?.codeValueID?.codeValue} ${item.shortDescription}`,
                value: item?.codeValueID?.codeValue,
              };
            }
          );
          categoryCodeData.sort((a, b) => a.value.localeCompare(b.value));
          categoryCodeData.unshift({
            label: 'ALL Applies to all categories',
            value: 'ALL',
          });
        }

        if (response.data && response.data.PROVIDER_ID_TYPE_CD) {
          providerIdTypeData = response.data.PROVIDER_ID_TYPE_CD.map(
            (item, index) => {
              return {
                ...item,
                index,
                label: `${item?.codeValueID?.codeValue} ${item.shortDescription}`,
                value: item?.codeValueID?.codeValue,
              };
            }
          ).sort((a, b) => a.value.localeCompare(b.value));
        }

        dispatch(setClaimReferenceData(response.data));
        dispatch(setClaimProviderIdTypeDropdown(providerIdTypeData));
        dispatch(setClaimCategoryCodeDropdown(categoryCodeData));
      } else {
        dispatch(setClaimReferenceData(null));
        dispatch(setClaimProviderIdTypeDropdown([]));
        dispatch(setClaimCategoryCodeDropdown([]));
      }
    } catch (e) {
      dispatch(setClaimReferenceData(null));
      dispatch(setClaimProviderIdTypeDropdown([]));
      dispatch(setClaimCategoryCodeDropdown([]));
    }
  };
};

export const getAllRebateProgramCode = () => {
  return async (dispatch) => {
    dispatch(setClaimLoading(true));
    try {
      const response = await axios.get(
        serviceEndPoint.GET_ALL_NONSUPP_REBATE_PROGRAM
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        const rebateData = [];
        response.data.data.forEach((item, index) => {
          rebateData.push({
            ...item,
            index,
            label: `${item.rebateProgramCd} | ${item.shortDescr}`,
            value: item.rebateProgramCd,
          });
        });
        rebateData.sort((a, b) => a.value.localeCompare(b.value));
        rebateData.unshift({ label: 'All Rebate Program', value: 'ALL' });

        dispatch(setClaimRebateProgramDropdown(rebateData));
      } else {
        dispatch(setClaimRebateProgramDropdown([]));
      }
    } catch (e) {
      dispatch(setClaimRebateProgramDropdown([]));
    }
    dispatch(setClaimLoading(false));
  };
};

export const getClaimClientCode = (values) => async (dispatch) => {
  dispatch(setClaimLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_CLIENT_CODE}`,
      values
    );
    if (response.data && response.data.length > 0) {
      const clientData = response.data.map((item, index) => {
        return {
          ...item,
          index,
          label: `${item?.cgpId?.clientId} ${item.clientName}`,
          value: item?.cgpId?.clientId,
        };
      });
      dispatch(setClaimClientDropdown(clientData));
    } else {
      dispatch(setClaimClientDropdown([]));
    }
  } catch (e) {
    dispatch(setClaimClientDropdown([]));
  }

  dispatch(setClaimLoading(false));
};

export const getClaimGroupCode = (values) => async (dispatch) => {
  dispatch(setClaimLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_GROUP}`,
      values
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      const groupData = response.data.data.map((item, index) => {
        return {
          ...item,
          index,
          label: `${item?.clientGroupId?.groupId} ${item.groupName}`,
          value: item?.clientGroupId?.groupId,
        };
      });
      dispatch(setClaimGroupDropdown(groupData));
    } else {
      dispatch(setClaimGroupDropdown([]));
    }
  } catch (e) {
    dispatch(setClaimGroupDropdown([]));
  }

  dispatch(setClaimLoading(false));
};

export const getClaimPlanCode = (values) => async (dispatch) => {
  dispatch(setClaimLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_PLAN}`,
      values
    );
    if (response.data && response.data.length > 0) {
      const planData = response.data.map((item, index) => {
        return {
          ...item,
          index,
          label: `${item?.cgpId?.planId} ${item.planName}`,
          value: item?.cgpId?.planId,
        };
      });
      dispatch(setClaimPlanDropdown(planData));
    } else {
      dispatch(setClaimPlanDropdown([]));
    }
  } catch (e) {
    dispatch(setClaimPlanDropdown([]));
  }

  dispatch(setClaimLoading(false));
};

export const callSearchClaimAPI = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.SEARCH_CLAIM, values);
    if (
      response.data &&
      response.data?.data &&
      response?.data?.data?.length > 0
    ) {
      return response.data.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const navigateToClaim = (
  filter,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async (dispatch, getState) => {
    try {
      const response = await callSearchClaimAPI(filter);
      if (response && response.length > 0) {
        //dispatch(setSelectedClaimFilterNu(null));
        dispatch(setSelectedClaimNu(response || []));
        // Reset pagination to page 1 when navigating from other screens
        dispatch(setSelectedClaimIndex(1));
        const userDefaults =
          getState().sharedState?.UserDefaultReducer?.UserDefaultsValues?.data;
        dispatch(
          setToggleDisputeResolution(
            getDisputeResolutionToggleFromUserDefault(userDefaults)
          )
        );
        onSuccess();
      } else {
        onError();
      }
    } catch (e) {
      onError();
    }
  };
};

export const GetAndDispatchClaimByID = (
  objClaimId,
  func,
  resetFilter = true,
  callClaimInfo = false
) => {
  return async (dispatch) => {
    dispatch(setClaimLoading(true));
    if (!objClaimId.claimId || !objClaimId.claimId.trim()) {
      dispatch(setClaimErrorPopupMessage('Claim ID is required.'));
    } else {
      const response = await callSearchClaimAPI(objClaimId);

      if (!response) {
        dispatch(
          setClaimErrorPopupMessage(
            `The requested claim is not on file. claim ID: ${objClaimId.claimId}.`
          )
        );
      } else {
        dispatch(setClaimErrorPopupMessage(null));
        if (resetFilter) {
          dispatch(setSelectedClaimFilterNu(null));
        }

        if (objClaimId.filterByDrugSeqNum && objClaimId.drugSeqNum) {
          const drugSeqNumToMatch = Number(objClaimId.drugSeqNum);

          if (Array.isArray(response)) {
            const allDrugSeqNums = response.flatMap(item =>
              (item.claimVOList || []).map(claim => claim?.drugVO?.drugSeqNum)
            );

            const filteredData = response.filter(item =>
              (item.claimVOList || []).some(
                claim => Number(claim?.drugVO?.drugSeqNum) === drugSeqNumToMatch
              )
            );

            dispatch(setSelectedClaimNu(filteredData));
          } else {
            dispatch(setSelectedClaimNu([]));
          }
        } else {
          dispatch(setSelectedClaimNu(Array.isArray(response) ? response : []));
        }

        if (func) func();
        if (callClaimInfo) {
          dispatch(getNOUClaimTableInfo(true));
          const claiminfo = response?.[0]?.claimVOList?.[0]?.claimIdVO;
          await axios.post(serviceEndPoint.SEARCH_CLAIM_DATA_INFO, [
            {
              ...claiminfo,
              userID: objClaimId.userID,
              functionCode: 'Number Of Units',
              eventInquryKeyVO: [
                {
                  keyType: 'claimId',
                  key: `${claiminfo.claimId}-${claiminfo.claimLineNum}`,
                },
              ],
            },
          ]);
        }
      }
    }

    dispatch(setClaimLoading(false));
  };
};

export const checkSuppRadioDisable = (rebateProgramCd) => {
  return async (dispatch) => {
    try {
      dispatch(setClaimLoading(true));
      const response = await axios.post(serviceEndPoint.SUPP_RADIO_CHECK, {
        rebateProgramCdAll: rebateProgramCd === 'ALL' ? 1 : null,
        planTypeCd: ['SUPP'],
        rebateProgramCd:
          rebateProgramCd === 'ALL' ? undefined : rebateProgramCd,
      });
      dispatch(setClaimSuppRadioDisable(response.data));
    } catch (e) {
      dispatch(setClaimRebateType(RegularSuppData[0].value));
      dispatch(setClaimSuppRadioDisable(true));
    }
    dispatch(setClaimLoading(false));
  };
};

export const formatQuater = (quater) => {
  const getCurrentCentury = new Date()
    .getUTCFullYear()
    .toString()
    .substring(0, 2);
  const splitQuater = quater.split('Q');
  let returnQuater = quater;
  if (splitQuater.length === 2 && splitQuater[1].length === 2) {
    returnQuater = `${splitQuater[0]}Q${getCurrentCentury}${splitQuater[1]}`;
  }
  return returnQuater;
};

export const searchClaimByNDCNu = (open = true, limitTo1000 = false) => {
  return async (dispatch, getState) => {
    const currentinnvoiceSelected = {
      ...getState().sharedState.NumberOfUnits.invoiceSelected,
    };

    const currentRebateType =
      getState().sharedState.NumberOfUnits.rebateType;

    const userId =
      getState().sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.userId;

    const currentFilter = {
      ...getState().sharedState.NumberOfUnits.claimSelectByFilter,
      searchByNdc: true,
      userID: userId,
    };

    const currentDetailsTable = [
      ...getState().sharedState.NumberOfUnits.claimDetailsTableData,
    ];

    const claimDetailsTableRowSelected = [
      ...getState().sharedState.NumberOfUnits.claimDetailsTableRowSelected,
    ];
    const tableDrugSeqSet = new Set(
      currentDetailsTable.map((row) => row.drugSeqNum)
    );

    const validSelectedDrugSeqs = claimDetailsTableRowSelected
      .map((row) => row.drugSeqNum)
      .filter((seq) => tableDrugSeqSet.has(seq));

    let drugSeqList =
      validSelectedDrugSeqs.length > 0
        ? [...new Set(validSelectedDrugSeqs)]
        : [...tableDrugSeqSet];

    if (limitTo1000 && drugSeqList.length > 1000) {
      drugSeqList = drugSeqList.slice(0, 1000);
    }

    currentFilter.drugSqnNum = drugSeqList;
    const paidQtrValue = currentFilter.paidQtr;
    const { processedQtr } = currentFilter;

    currentFilter.rebateProgramCd =
      currentFilter.rebateProgramCd === 'ALL'
        ? null
        : currentFilter.rebateProgramCd;

    currentFilter.paidDate =
      paidQtrValue && paidQtrValue.includes('/')
        ? paidQtrValue
        : undefined;

    currentFilter.paidDt = undefined;

    currentFilter.paidQtr =
      paidQtrValue && paidQtrValue.includes('Q')
        ? formatQuater(paidQtrValue)
        : undefined;

    currentFilter.processedQtr = processedQtr
      ? formatQuater(processedQtr)
      : undefined;

    currentFilter.claimCategoryCd =
      currentFilter.claimCategoryCd === 'ALL'
        ? null
        : currentFilter.claimCategoryCd;

    dispatch(setClaimLoading(true));

    const response = await callSearchClaimAPI(currentFilter);

    if (!response) {
      dispatch(
        setClaimErrorPopupMessage(
          'No claims were found matching the provided criteria.'
        )
      );
    } else {
      let totalClaimFound = 0;
      const selectedClaimData = [];

      response.forEach((item) => {
        const filterArr = item.claimResultVOList.filter((items) => {
          const key =
            currentRebateType === RegularSuppData[0].value
              ? 'invoiceInd'
              : 'suppInvoicedInd';

          if (
            currentinnvoiceSelected.invoiced &&
            currentinnvoiceSelected.nonInvoiced
          ) {
            return items[key] === 1 || items[key] === 0;
          }
          return items[key] ===
            (currentinnvoiceSelected.invoiced ? 1 : 0);
        });

        totalClaimFound += filterArr.length;

        if (filterArr.length > 0) {
          selectedClaimData.push({ ...item });
        }
      });

      if (totalClaimFound === 0) {
        dispatch(
          setClaimErrorPopupMessage(
            'No claims were found matching the provided criteria.'
          )
        );
      } else {
        dispatch(setClaimErrorPopupMessage(null));
        dispatch(
          setClaimDetailsPopup({
            open: open,
            total: totalClaimFound,
            data: selectedClaimData,
          })
        );
        dispatch(setSelectedClaimNu(selectedClaimData));
      }
    }

    dispatch(setClaimLoading(false));
  };
};

export const navigateToProvider = (input, func) => {
  return async (dispatch) => {
    try {
      const searchInput = {
        page: '0',
        pageSize: '100',
        providerIdTypeCd: 'ALL',
        searchBy: 'ID',
        searchVal: input.providerId,
      };
      const searchResponse = await axios.post(
        serviceEndPoint.SEARCH_PROVIDER_DETAILS,
        searchInput
      );

      if (
        searchResponse.data &&
        searchResponse.data.data &&
        searchResponse.data.data.length > 0
      ) {
        const detailsResponse = await axios.post(
          serviceEndPoint.GET_PROVIDER_DETAILS,
          input
        );

        dispatch(dispatchProvideDetails(searchResponse.data.data[0]));
        if (detailsResponse.data) {
          dispatch(dispatchProvideDetailsData(detailsResponse.data));
          func();
        }
      }
    } catch (e) {
      dispatch(dispatchProvideDetailsData({ error: 'API failed' }));
    }
  };
};

export const PostNumOfUnits = (values) => async (dispatch) => {
  dispatch(setNumUnitLoading(true));
  try {
    // const response = await axios.post(`${serviceEndPoint.TEST}`, values);
    const response = await axios.post(UPDATE_NUM_OF_UNITS, values);
    if (response?.data) {
      if (typeof response?.data === 'string') {
        dispatch(setNumOfUnitRes({ status: '200', message: response?.data }));
      }  else if (typeof response?.data === 'object' && response?.data?.status == '002') {
        dispatch(setErrorMessage([ConstantMessageData.FAILED_MESSAGE_GENERIC]));
      } else {
        dispatch(setNumOfUnitRes(response.data));
      }
    } else {
      dispatch(setNumOfUnitRes([]));
    }
  } catch (error) {
    // Check for network error
    if (error.isAxiosError && !error.response) {
      // Network error handling
      dispatch(
        setNumOfUnitRes({ status: 500, message: 'Network error occurred' })
      );
    } else {
      // Other error handling
      dispatch(setNumOfUnitRes(error.message || 'An error occurred'));
    }
  }

  dispatch(setNumUnitLoading(false));
};

export const setEditedDataNu = (payload) => {
  return {
    type: TYPES.SET_EDITED_DATA_NU,
    payload,
  };
};

export const setEditedRows = (payload) => {
  return {
    type: TYPES.SET_EDITED_ROWS,
    payload,
  };
};

export const resetEditedRows = () => {
  return {
    type: TYPES.RESET_EDITED_ROWS,
  };
};

export const dispatchGetNumOfUnitsExtraState = (data) => ({
  type: TYPES.NUMOFUNITS_EXTRA_STATE,
  extraState: data,
});

export const setNumOfUnitsExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetNumOfUnitsExtraState(value));
};

export const setErrorMessage = (data) => ({
  type: TYPES.SET_ERROR_MESSAGE,
  errorMessage: data,
});

export const setClaimId = (payload) => {
  return {
    type: TYPES.SET_CLAIM_ID,
    payload,
  };
};

export const setCellFocused = (data) => {
  return {
    type: TYPES.SET_CELL_FOCUSED,
    payload: data,
  };
};

export const setSinglePageClaimDataNu = (data) => ({
  type: TYPES.SET_SINGLE_PAGE_CLAIM_DATA_NU,
  payload: data,
});
export const getSinglePageClaimData = (values) => async (dispatch) => {
  // dispatch(setNumUnitLoading(true));

  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_CLAIM_DATA_INFO,
      values
    );
    if (response?.data) {
      const tempObj = response?.data?.data?.map((item) => {
        if (item.billedUnits === null) {
          item.billedUnits = item.origNumOfUnits;
        }
        return item;
      });
      dispatch(setSinglePageClaimDataNu(tempObj || []));
    } else {
      dispatch(setSinglePageClaimDataNu([]));
    }

    // dispatch(setSinglePageClaimData(response.data));
  } catch (error) {}

  dispatch(setNumUnitLoading(false));
};
export const clearReduxNumberOfUnitSearchScreen = (payload) =>(dispatch)=> {
  // Dispatch these actions as required by your logic
  // dispatch(setClaimErrorPopupMessage([]));
  // dispatch(setClaimRebateProgramDropdown([]));
  // dispatch(setClaimSelectByFilter({}));
  // dispatch(setClaimCategoryCodeDropdown([]));
  // dispatch(setClaimProviderIdTypeDropdown([]));
  if(payload==='/units-claim'){
  dispatch(setDisabled(true));  
  dispatch(setClaimSelectByFilter({}));
  dispatch(setClaimErrorPopupMessage([]));
  dispatch(setClaimCategoryCode(null));
  dispatch(setClaimSelectByFilter({}));
  dispatch(setClaimDetailsTableData([]));
  dispatch(setClaimLabelerDrugTableData([]));
  dispatch(setClaimSearchByDrugNameTableData([]));
  dispatch(setSearchByDrugName(''));
  dispatch(setEnteredNdc(null));
  dispatch(setClaimId(''));
  dispatch(setClaimInvoiceSelected({ invoiced: true, nonInvoiced: false }))
  dispatch(setClaimSelectedNDCTab(''))
  dispatch(setNumberOfUnitSelectBy('ndc'))
  }
    localStorage.setItem('selectedClaimCategoryCd', JSON.stringify([]));


  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const shouldDispatchAction =
    (payload === '/units-claim' &&
      !updateTabs.some((x) => x.navTo === '/units-selected-claim')) ||
    (payload === '/units-selected-claim' &&
      !updateTabs.some((x) => x.navTo === '/units-claim'));
  if (shouldDispatchAction) {
    return {
      type: TYPES.CLEAR_REDUX_DATA_CLAIM,
      payload,
    };
  }
  return {
    type: TYPES.NO_ACTION_TAKEN,
  };
};
export const setNoOfUnitsSearchScreenObj = (data) => ({
  type: TYPES.NO_OF_UNITS_SEARCH_TAB_DATA,
  searchScreenReduxObj: data,
});
